// Shift times are local to the event's time zone and carry no offset: read and
// format them as UTC so the browser's own time zone never shifts them.
const rangeFormat = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  hour: '2-digit',
  minute: '2-digit',
  timeZone: 'UTC',
})

const dayFormat = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'short',
  day: 'numeric',
  month: 'short',
  timeZone: 'UTC',
})

const asDate = (local: string) => new Date(`${local}Z`)

/** `sam. 6 févr.` for the day `2027-02-06`. */
export function formatDay(day: string): string {
  return dayFormat.format(asDate(`${day}T00:00:00`))
}

/** `sam. 6 févr., 08:00 – 10:00`, with both days when the range spans midnight. */
export function formatRange(startsAt: string, endsAt: string): string {
  return rangeFormat.formatRange(asDate(startsAt), asDate(endsAt))
}

/** `local` moved by `minutes`, in the same format. */
export function addMinutes(local: string, minutes: number): string {
  return new Date(asDate(local).getTime() + minutes * 60_000).toISOString().slice(0, 19)
}

export function minutesBetween(startsAt: string, endsAt: string): number {
  return Math.round((asDate(endsAt).getTime() - asDate(startsAt).getTime()) / 60_000)
}

/** `2 h`, `1 h 30`, `45 min`. */
export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60)
  const rest = minutes % 60
  if (hours === 0) return `${rest} min`
  return rest === 0 ? `${hours} h` : `${hours} h ${String(rest).padStart(2, '0')}`
}

/** Value of a `datetime-local` input. */
export const toInput = (local: string) => local.slice(0, 16)

/** The API expects seconds, which `datetime-local` inputs omit. */
export const fromInput = (value: string) => (value.length === 16 ? `${value}:00` : value)
